import { memo } from 'react'
import { faDiscord } from '@fortawesome/free-brands-svg-icons'
import { useDispatch, useSelector } from 'react-redux'

import SubmitButton from '../shared/button/SubmitButton'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import Text from '../shared/text/Text'
import { CUSTOM_BRAND_ID } from '../../constants/pointsExchange'
import { selectEarnViaProfile } from '../../store/selectors/common'
import { extractMembershipNumber } from '../../util/pointsExchange.helpers'
import { connectSocialAccount } from '../../store/actions/earnVia'
import { Stack } from '@mui/material'

const DiscordConnect = ({ exchangeMemberships, t }) => {
  const dispatch = useDispatch()

  const { error, currentBrandId, connecting } =
    useSelector(selectEarnViaProfile)

  const connectedDiscord = extractMembershipNumber(exchangeMemberships, {
    brandId: CUSTOM_BRAND_ID.DISCORD
  })

  const handleOnConnect = () => {
    dispatch(connectSocialAccount(CUSTOM_BRAND_ID.DISCORD))
  }
  return (
    <Stack spacing={1} alignItems='center'>
      <SubmitButton
        type='button'
        size='default'
        fullWidth={false}
        label={t(
          `social-connect.${connectedDiscord ? 'change' : 'connect'}-discord`
        )}
        variant={connectedDiscord ? 'outlined' : 'contained'}
        onClick={handleOnConnect}
        loading={connecting && currentBrandId === CUSTOM_BRAND_ID.DISCORD}
        startIcon={<FaIcon icon={faDiscord} />}
      />
      {error?.[CUSTOM_BRAND_ID.DISCORD] && (
        <Text
          label={t(error[CUSTOM_BRAND_ID.DISCORD])}
          color='error'
          sx={{ mt: 1, textAlign: 'center' }}
        />
      )}
    </Stack>
  )
}

export default memo(DiscordConnect)
